// extracted by mini-css-extract-plugin
var _1 = "tooltip-inner__cyFbo";
export { _1 as "tooltip-inner" }
